<template>
    <div>
        <div class="text-center">
            <h3 class="mx-auto bg-info text-center" style="width: 85%">{{title}}</h3>
        </div>
        <transition v-if="points" name="slide-fade" mode="out-in">
            <div class="mx-auto" style="width: 85%">
                <b-list-group>
                    <b-card v-if="points" no-body>
                        <b-list-group v-for="point in points" v-bind:key="point">
                            <b-list-group-item>
                                {{point}}
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>

                </b-list-group>
            </div>
        </transition>
        <br/>
    </div>
</template>

<script>
    export default {
        name: "Extracurricular",
        props: {
            title: {
                required: true,
                type: String
            },
            points: {
                type: Array
            }
        }
    }
</script>

<style scoped>

</style>
